import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { Device, DeviceList } from "../../interface/device";
import { DeviceType } from "../../interface/device-type";
import { KpiGroups } from "../../interface/kpi-groups";
import {
  HttpClient
} from "@angular/common/http";

@Injectable()
export class DeviceService {
  deviceAction = new Subject();

  constructor(private router: Router, private httpClient: HttpClient) { }

  // Create device
  create(form): Observable<any> {
    let body = form;

    return this.httpClient.post("device", body);
  }

  update(form): Observable<any> {
    let body = form;
    return this.httpClient.patch("device", body);
  }

  // List of all devices
  list(filter = ""): Observable<Device[]> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<Device[]>("device" + filter);
  }

  count(filter = ""): Observable<any> {
    filter = "?" + filter;
    return this.httpClient.get<any>("device" + filter + "&count=1");
  }

  //Fetch Device Types
  types(): Observable<DeviceType[]> {
    return this.httpClient.get<DeviceType[]>("device/type");
  }

  //Fetch KPI groups
  kpiGroups(id): Observable<KpiGroups[]> {
    return this.httpClient.get<KpiGroups[]>("kpi/kpiGroupByDeviceType/" + id);
  }

  //Delete Device
  delete(deviceid) {
    return this.httpClient.delete("device/" + deviceid);
  }

  getAction(): Observable<any> {
    return this.deviceAction.asObservable();
  }

  sendAction(action, data) {
    this.deviceAction.next({ action: action, data: data });
  }

  resolve(deviceId): Observable<any> {
    return this.httpClient.get('device/resolve/' + deviceId);
  }
  
  fetchData(deviceId): Observable<any> {
    return this.httpClient.get('device/fetchData/' + deviceId);
  }

  checkConnection(data): Observable<any> {
    return this.httpClient.post('device/test', data);
  }

  getDeviceList(filter = ""): Observable<DeviceList[]> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<DeviceList[]>("device/list" + filter);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/device/device.service.ts